<template>
  <span class="modeOfOperationWidget" :class="{'animate-flicker': isLoading}">
    <template v-if="value === 'AUTOMATIC'">
      <span title="Automatic Mode">
        <v-icon
          v-if="!disabled"
          pl-1
          color="green"
          :size="iconSize"
          >motion_photos_auto</v-icon
        >
        <v-icon
          v-else
          pl-1
          color="rgb(192, 192, 192)"
          :size="iconSize"
        >motion_photos_auto</v-icon
        >
      </span>
    </template>
    <template v-else>
      <span title="Manual Mode">
        <v-icon
          v-if="!disabled"
          pl-1
          color="red"
          :size="iconSize"
          >motion_photos_auto</v-icon
        >
        <v-icon
          v-else
          pl-1
          color="rgb(192, 192, 192)"
          :size="iconSize"
        >motion_photos_auto</v-icon
        >
      </span>
    </template>
  </span>
</template>

<script>
import {EventBus} from "@/event-bus";

export default {
  name: "ModeOfOperation",
  props: ["value", "iconSize", "disabled", "item"],
  components: {},
  beforeMount() {},
  mounted() {
    EventBus.$on('mode-of-operation-loading', this.isLoadingSet)
  },
  unmounted() {
    EventBus.$off('mode-of-operation-loading', this.isLoadingSet)
  },
  data() {
    return {
      isLoading: false
    };
  },

  computed: {},
  watch: {
    value() {
      this.isLoading = false
    }
  },
  methods: {
    isLoadingSet(payload) {
      if (payload.platformGroupId === this.item.platformGroup_id) {
        this.setIsLoading(payload.isLoading)
      }
    },
    setIsLoading(isLoading) {
      this.isLoading = isLoading
      setTimeout(() => {
        this.isLoading = false
      }, 10*1000)
    }
  }
};
</script>
